// 导入自己需要的组件
import { Input,CascaderPanel,Cascader,Popover } from 'element-ui'
const element = {
    install: function (Vue) {

        Vue.use(CascaderPanel)
        Vue.use(Cascader)
        Vue.use(Input)
        Vue.use(Popover)

    }
}
export default element
